import 'tippy.js/dist/tippy.css';
import Tippy from '@tippyjs/react';
import classNames from 'classnames';

import { MapPinned, Trophy } from 'lucide-react';
import { ChampionshipStatus } from 'modules/championship/domain/enums/championship-status';
import { ChampionshipListItem } from 'modules/championship/domain/interfaces/championship-list-item';
import { ChampionshipEncoded } from 'modules/championship/domain/interfaces/championship-encoded';
import React, { useCallback } from 'react';
import UDText from 'ud-ui/components/text';

import { DivProps } from 'typings';

import * as S from './styles';

type Props = {
  // championship: ChampionshipEncoded;
  championship: ChampionshipListItem;
  containerProps?: Omit<DivProps, 'children' | 'onClick'>;
  onClickCard: (id: ChampionshipEncoded['id']) => any;
};

const statusIndicatorMessage = {
  [ChampionshipStatus.OPEN]: 'Прием заявок открыт',
  [ChampionshipStatus.CLOSE]: 'Прием заявок закрыт',
};

const ChampionshipCard = (props: Props) => {
  const start = props.championship.startDate ? new Date(props.championship.startDate).toLocaleDateString('ru') : null;
  const end = props.championship.endDate ? new Date(props.championship.endDate).toLocaleDateString('ru') : null;

  const onClickCard = useCallback(() => {
    props.onClickCard(props.championship.id);
  }, [props]);

  return (
    <S.CardContainer
      {...props.containerProps}
      className={classNames('flex flex-col py-4 pr-4 pl-3', props.containerProps?.className)}
      onClick={onClickCard}
    >
      <div className="mb-5 flex flex-row items-center">
        <Trophy size={16} className="mr-1" />
        <UDText type="caption-2" className="text-surfaceRomanSilver30">
          Турнир
        </UDText>
        <MapPinned size={16} className="text-surfaceRomanSilver30 mr-1 ml-auto" />
        <UDText type="caption-2" className="text-surfaceRomanSilver30">
          {props.championship.address?.city}
        </UDText>
      </div>
      <S.StyledTournamentName type="subhead" className="bold">
        {props.championship.name}
      </S.StyledTournamentName>
      <div className="mt-auto flex flex-row items-center justify-between">
        <UDText type="subhead" className="date text-surfaceRichBlack60">
          {start} — {end || <span className="text-surfaceRomanSilver30">открытая дата</span>}
        </UDText>
        <Tippy content={statusIndicatorMessage[props.championship?.status ?? ChampionshipStatus.CLOSE]} placement="right" interactive={false}>
          <S.StatusIndicator data-status={props.championship?.status} />
        </Tippy>
      </div>
    </S.CardContainer>
  );
};

export default ChampionshipCard;
